module.exports = __webpack_public_path__ + "img/pedido-confirmacao.bf990f73.gif";